import Document from '@tiptap/extension-document';
import {Heading} from '@tiptap/extension-heading';
import History from '@tiptap/extension-history';
import Placeholder from '@tiptap/extension-placeholder';
import Text from '@tiptap/extension-text';
import {TiptapConfig, TiptapPreset} from '../types';

export const titleTextPreset = (config: TiptapConfig): TiptapPreset => {
  return {
    extensions: [
      Document.extend({
        content: 'heading block*',
      }),
      Heading.configure({
        levels: [1],
      }),
      Text,
      History,
      Placeholder.configure({
        placeholder: ({node}) => {
          if (node.type.name === 'heading') {
            return config.placeholder || '...';
          }
          return config.placeholder || '...';
        },
      }),
    ],
    format: 'plain',
    toolbar: false,
  };
};
